export class Cycle {
  cycleID: number;
  cycle: string;
  startDate?: string;
  endDate?: string;
  name: string;
  fPYear?: number;
  fPYearOrder?: number;
  longName?: string;

  constructor(
    cycleID: number,
    cycle: string,
    name: string,
    startDate?: string,
    endDate?: string,
    fPYear?: number,
    fPYearOrder?: number,
    longName?: string,
  ) {
    this.cycleID = cycleID;
    this.cycle = cycle;
    this.name = name;
    this.startDate = startDate;
    this.endDate = endDate;
    this.fPYear = fPYear;
    this.fPYearOrder = fPYearOrder;
    this.longName = longName;
  }
}

